import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../../services/general.service';
import { ServicingService } from '../../../../../services/servicing.service';
import { CustomersService } from '../../../../../services/customers.service';

import { exit } from 'process';

declare var $: any;

@Component({
  selector: 'app-customers-operating',
  templateUrl: './customers-operating.component.html',
  styleUrls: ['./customers-operating.component.css']
})

export class CustomersOperatingComponent implements OnInit {

  @Input() ID: string;
  @Input() SID: string;
  @Input() OID: string;
  @Input() PID: string;
  @Input() langs: string;

  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  serviceId: string;
  plan_id: string;
  intervention_id: string;
  lang: any;
  generalLang: any;
  cid: any;
  record: any;
  mode: string;
  data_action: any;
  operatingTab: any;
  generalTab: any;

  //common data
  data: any;

  imageLink: any;
  id: number;
  action: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private servicingService: ServicingService,
    private customersService: CustomersService,
    private router: Router,
    private route: ActivatedRoute,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.generalTab = '';
    this.operatingTab = 'activeTab';
    
    this.getData();
    this.FormBuild();

    this.config();
    this.fileDesign();


  }



  config(): void {


    this.typeConfig = [
      { value: 'EQUIPMENT', text: 'VEHICLE' },
      { value: 'PLANT', text: 'PLANT' },
      { value: 'MACHINE', text: 'MACHINE' },
      { value: 'FIRE DISPENSER', text: 'FIRE DISPENSER' },
      { value: 'FIRST SERVICE DEVICE', text: 'FIRST SERVICE DEVICE' },
      { value: 'INDIVIDUAL PROTECTION DEVICE', text: 'INDIVIDUAL PROTECTION DEVICE' },
      { value: 'SAFETY EQUIPMENT', text: 'SAFETY EQUIPMENT' }
    ];



    this.planConfig = [
      { value: '7', text: '33 - e3' },
      { value: '18', text: 'sarda - add' },
      { value: '145', text: 'S 001 - test' }
    ];


    this.emp_id = [
      { value: '886', text: 'demotest demotest' },
      { value: '885', text: 'dtesttest dtesttest' },
      { value: '523', text: 'PAOLO ROSSI' },
      { value: '739', text: 'Test 01' }
    ];


  }

  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      address: ['', [Validators.required]],
      zip_code: ['', [Validators.required]],
      city: ['', [Validators.required]],
      province: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required]],
      notes: ['', [Validators.required]],
      id: '',
      cid: this.cid,
      action: 'update_service',
    });

    this.createFormErrorMsg = {
      'address': [{ type: 'required', message: 'This field is Required' }],
      'zip_code': [{ type: 'required', message: 'This field is Required' }],
      'city': [{ type: 'required', message: 'This field is Required' }],
      'province': [{ type: 'required', message: 'This field is Required' }],
      'phone': [{ type: 'required', message: 'This field is Required' }],
      'email': [{ type: 'required', message: 'This field is Required' }],
      'notes': [{ type: 'required', message: 'This field is Required' }],

    }

    setTimeout(() => this.fileDesign(), 10);

    // this.service_attach_exists().valueChanges.subscribe(values => {
    //   setTimeout(() => this.fileDesign(), 10);
    // });

    // this.service_image_exists().valueChanges.subscribe(values => {
    //   setTimeout(() => this.fileDesign(), 10);
    // });


  }

  FormBuildUpdate(): void {

    this.createForm.patchValue({
      address: this.record.ol_address,
      zip_code: this.record.zip_code,
      city: this.record.city,
      province: this.record.province,
      phone: this.record.phone,
      email: this.record.e_mail,
      notes: this.record.notes,
      id: this.record.operating_loctionids,
      cid: this.record.customer_id,
    });
  }

  // send_email() : FormArray {
  // return this.createForm.get("send_email") as FormArray
  //  }

  // newEmail(data = ''): FormControl {
  // return new FormControl(data, Validators.email);
  // }

  // addEmail() {
  // this.send_email().push(this.newEmail());
  // }

  // removeEmail(i:number) {
  // this.send_email().removeAt(i);
  // }

  // emptyEmail() {
  // while (this.send_email().controls.length > 0) {
  // this.send_email().removeAt(0);
  // }
  // }

  ex_document_link(): FormArray {
    return this.createForm.get('ex_document_link') as FormArray;
  };

  service_image_exists(): FormArray {
    return this.createForm.get('service_image_exists') as FormArray;
  };

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      // link: ['', [ValidateExtension(['csv','doc','docx','pptx','txt','pdf','xlsx','xls'])]]
      link: ['']
    });
  }

  addAttachment(): void {
    this.ex_document_link().push(this.newAttachment());
  }

  removeAttachment(i: number) {
    this.ex_document_link().removeAt(i);
  }

  // timetable_link_uploaded(): FormArray {
  // return this.createForm.get('timetable_link_uploaded') as FormArray;
  // };

  // removeAttachmentUploaded(i: number) {
  // this.timetable_link_uploaded().removeAt(i);
  // }

  service_attach_uploaded(): FormArray {
    return this.createForm.get('service_attach_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.service_attach_uploaded().removeAt(i);
  }

  service_image_uploaded(): FormArray {
    return this.createForm.get('service_image_uploaded') as FormArray;
  };

  removeAttachmentUploaded1(i: number) {
    this.service_image_uploaded().removeAt(i);
  }



  public selectAttachment(event: any, index) {

    this.createForm.value.service_image_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.service_image_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  public selectAttachment1(event: any, index) {

    this.createForm.value.ex_document_link[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.ex_document_link[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }

  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }




  // getData() {

  //   if (this.ID) 
  //   {
  //   this.mode = 'Edit';
  //   this.modalTitle = 'Edit Servicing';
  //   }
  //   else 
  //   {
  //   this.mode = 'Create';
  //   this.modalTitle = 'Create Servicing';
  //   }
  // }

  getData() {

    // console.log(this.ID); return false;

    if (this.OID) {
      this.customersService.editoperating(this.OID).subscribe(
        res => {

          if (!res.status) {
            this.generalService.notify_msg('error', 'Some problems in getting details');
            this.bsModalRef.hide();
            return;
          }

          this.record = res.data.edit_data;
          this.FormBuildUpdate();
        }
      );
      this.generalLang = this.langs;

      this.mode = 'Edit';
      this.modalTitle = this.generalLang.operatingLocations;
    }
    else {
      this.generalLang = this.langs;
      this.cid = this.SID;
      // console.log(this.cid);
      // console.log(this.generalLang);
      this.mode = 'Create';
      this.modalTitle = this.generalLang.operatingLocations;
      

    }


  }


  onSubmit() {

    // console.log(this.createForm.value); return false;

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

    //   console.log('test12'); return false;

  this.customersService.update_operating(this.createForm.value).subscribe(
      res => {



        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();

          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW+'/'+this.SID]);
            });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }

  checkValue(val)
  {
    if (val == 'change') {
      $('#referdate').show();
    }
    else {
      $('#referdate').hide();
    }
  }

}
